import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import Home from './views/Home.vue'
import store from './store'

// import swiper from './components/swiper'
// import AboutUs from './views/AboutUs.vue'
// console.log('recruit host ==========>', process.env.VUE_APP_RECRUIT)

// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(Router)

// lazy-loaded
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const router = new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    // {
    // 	path: '/',
    // 	name: 'subscribe',
    // 	component: loadView('subscribe')
    // },

    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
        {
          path: '/help',
          name: 'help',
          component: loadView('help/index'),
          meta: {
            title: 'ブルーアーカイブ',
            description: 'Yostarが新たに贈る、スマートフォン向けアプリゲーム 学園×青春×物語RPG『ブルーアーカイブ -Blue Archive-』の公式サイトです。',
            keywords: 'スマホ, アズ旅,スマートフォン,デジタルスタンプラリー,沖縄,yostar,よーすたー,ヨースター',
            ogUrl: 'https://bluearchive.jp/help/',
            ogTitle: 'ブルーアーカイブ',
            ogSiteName: 'ブルーアーカイブ',
            ogDescription: 'Yostarが新たに贈る、スマートフォン向けアプリゲーム 学園×青春×物語RPG『ブルーアーカイブ -Blue Archive-』の公式サイトです。',
          },
        },
        {
          path: '/help/list',
          name: 'helpList',
          component: loadView('help/list'),
          meta: {
            title: 'ブルーアーカイブ',
            description: 'Yostarが新たに贈る、スマートフォン向けアプリゲーム 学園×青春×物語RPG『ブルーアーカイブ -Blue Archive-』の公式サイトです。',
            keywords: 'スマホ, アズ旅,スマートフォン,デジタルスタンプラリー,沖縄,yostar,よーすたー,ヨースター',
            ogUrl: 'https://bluearchive.jp/help/',
            ogTitle: 'ブルーアーカイブ',
            ogSiteName: 'ブルーアーカイブ',
            ogDescription: 'Yostarが新たに贈る、スマートフォン向けアプリゲーム 学園×青春×物語RPG『ブルーアーカイブ -Blue Archive-』の公式サイトです。',
          },
        },
        {
          path: '/faq',
          name: 'faq',
          component: loadView('faq'),
        },
        {
          path: '/fankit',
          name: 'fankit',
          component: loadView('fankit'),
        },
        {
          path: 'fankit/precautions',
          name: 'Precautions',
          component: loadView('fankit/Precautions'),
        },
        {
          path: 'fankit/guidelines',
          name: 'Guidelines',
          component: loadView('fankit/Guidelines'),
        },
        {
          path: '/news',
          name: 'news',
          component: loadView('news'),
        },
        {
          path: '/news/newsJump',
          name: 'newsJump',
          component: loadView('newsJump'),
        },
        {
          path: '/news/newsJump/:id',
          name: 'newsContext',
          component: loadView('newsJump_context'),
        },
        // {
        //   path: '/newsjumps/:id',
        //   name: 'newsjumps',
        //   component: loadView('newsjumps'),
        // },
        {
          path: '/character',
          name: 'character',
          component: loadView('character'),
        },
        {
          path: '/system',
          name: 'system',
          component: loadView('system'),
        },
        {
          path: '/contact-1-hint',
          name: 'contact-1-hint',
          component: loadView('contact'),
        },
        {
          path: '/contact/1',
          name: 'contact1',
          component: loadView('contact_1'),
        },
        {
          path: '/contact/2',
          name: 'contact2',
          component: loadView('contact_2'),
        },
        {
          path: '/contact/3',
          name: 'contact3',
          component: loadView('contact_3'),
        },
        {
          path: '/contact/4',
          name: 'contact4',
          component: loadView('contact_4'),
        },
        {
          path: '/comics',
          name: 'comics',
          component: loadView('comics'),
        },
        {
          path: '/comics02',
          name: 'comics02',
          component: loadView('comics02'),
        },
        {
          path: '/comics/:chapters/:type',
          name: 'comicsID',
          component: loadView('comics'),
        },
        {
          path: '/comics02/:chapters/:type',
          name: 'comicsID',
          component: loadView('comics02'),
        },
        {
          path: '/bosyuu',
          name: 'bosyuu',
          component: loadView('bosyuu'),
          meta: {
            title: 'ブルアカファンアート募集',
          },
        },

        {
          path: '/serial_code',
          name: 'serial_code',
          component: loadView('serial_code'),
        },

      ],
    },
    {
      path: '/terms',
      name: 'terms_of_service',
      component: loadView('Terms_of_service'),
    },
    {
      path: '/privacy',
      name: 'privacy_policy',
      component: loadView('Privacy_policy'),
    },
    {
      path: '/specific_business',
      name: 'specific_business',
      component: loadView('Specific_business'),
    },
    {
      path: '/preregistration',
      name: 'subscribe',
      component: loadView('subscribe'),
    },
    {
      path: '/based',
      name: 'based',
      component: loadView('based_fund_settlement_law'),
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 设置或更新 meta 标签函数
  const updateMetaTag = (name, content) => {
    let metaTag = document.querySelector(`meta[name="${name}"]`);
    if (metaTag) {
      metaTag.setAttribute('content', content);
    } else {
      metaTag = document.createElement('meta');
      metaTag.name = name;
      metaTag.content = content;
      document.head.appendChild(metaTag);
    }
  };
  // 设置或更新 Open Graph meta 标签函数
  const updateOgMetaTag = (property, content) => {
    let metaTag = document.querySelector(`meta[property="${property}"]`);
    if (metaTag) {
      metaTag.setAttribute('content', content);
    } else {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('property', property);
      metaTag.content = content;
      document.head.appendChild(metaTag);
    }
  };
  // 设置页面描述
  if (to.meta.description) {
    updateMetaTag('description', to.meta.description);
  }
  // 设置页面关键词
  if (to.meta.keywords) {
    updateMetaTag('keywords', to.meta.keywords);
  }
  // 设置 Open Graph URL
  if (to.meta.ogUrl) {
    updateOgMetaTag('og:url', to.meta.ogUrl);
  }
  // 设置 Open Graph 标题
  if (to.meta.ogDescription) {
    updateOgMetaTag('og:title', to.meta.ogTitle);
  }
  // 设置 Open Graph 名称
  if (to.meta.ogDescription) {
    updateOgMetaTag('og:site_name', to.meta.ogSiteName);
  }
  // 设置 Open Graph 描述
  if (to.meta.ogDescription) {
    updateOgMetaTag('og:description', to.meta.ogDescription);
  }

  if (to.path.startsWith('/help')) {
    if (to.query && to.query.data) {
      localStorage.setItem('helpUserData', to.query.data);
      const { data, ...queryWithoutData } = to.query;

      next({
        path: to.path,
        query: queryWithoutData,
        replace: true
      });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router
